import { getApiBase, getAuthToken } from './api'

type SseHandler = (data: unknown) => void

let es: EventSource | null = null
const handlers = new Map<string, Set<SseHandler>>()
let reconnectTimer: ReturnType<typeof setTimeout> | null = null

function connect() {
  if (es) return
  const token = getAuthToken()
  if (!token) return
  const url = `${getApiBase()}/events?token=${encodeURIComponent(token)}`
  es = new EventSource(url)

  es.addEventListener('task-changed', (e: MessageEvent) => {
    dispatch('task-changed', JSON.parse(e.data))
  })

  es.onerror = () => {
    es?.close()
    es = null
    if (!reconnectTimer) {
      reconnectTimer = setTimeout(() => { reconnectTimer = null; connect() }, 5000)
    }
  }
}

function dispatch(event: string, data: unknown) {
  handlers.get(event)?.forEach((fn) => fn(data))
}

export function sseOn(event: string, handler: SseHandler) {
  if (!handlers.has(event)) handlers.set(event, new Set())
  handlers.get(event)!.add(handler)
  connect()
}

export function sseOff(event: string, handler: SseHandler) {
  handlers.get(event)?.delete(handler)
}

export function sseDisconnect() {
  if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null }
  es?.close()
  es = null
  handlers.clear()
}
